import { handleEditTemplateHost } from '@/composition/hosts/templates/template-builder/handle-edit-template-host';
import { useHandleEditTemplate } from '@heidi/templates';
import { useCallback } from 'react';

/**
 * Refreshes the saved template and opens its prepared editor record.
 * Legacy templates without a creation record are linked to a new record with
 * their saved name and selected version before navigation. Awaits the handoff
 * but discards its navigation result.
 */
export const useViewTemplateById = () => {
  const { handleViewTemplateById } = useHandleEditTemplate(handleEditTemplateHost);
  return useCallback(
    async (templateId: string) => {
      await handleViewTemplateById(templateId);
    },
    [handleViewTemplateById]
  );
};
